import { apiClient } from '../../../client'

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export interface VisitTypeKpi {
  id: number
  is_required: number
  list_order?: number | null
  by_track?: string | ''
  photo_type_id?: string | null
  default_value?: string | null
}

export interface VisitType {
  id: number
  tenant_id: number
  en_name: string
  ar_name: string
  description: string | null
  status: number
  created_by: number
  updated_by: number
  created_at: string
  updated_at: string
  type_kpis?: VisitTypeKpi[]
}

export interface VisitTypeFilters {
  search?: string
}

export interface CreateVisitTypeRequest {
  en_name: string
  ar_name: string
  description?: string
  status: number
  type_kpis: {
    id: number
    is_required: number
    list_order?: number | null
    by_track?: string | null
    photo_type_id?: string | null
    default_value?: string | null
  }[]
}

export interface UpdateVisitTypeRequest extends CreateVisitTypeRequest { }

class VisitTypesRepository {
  async findAll(
    page: number = 1,
    limit: number = 10,
    filters?: VisitTypeFilters
  ): Promise<PaginatedResponse<VisitType>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    })
    if (filters?.search) params.append('search', filters.search)
    return apiClient.get<PaginatedResponse<VisitType>>(`/visit-types?${params.toString()}`)
  }

  async getById(id: number): Promise<VisitType | null> {
    return apiClient.get<VisitType | null>(`/visit-types/${id}`)
  }

  async create(data: CreateVisitTypeRequest): Promise<VisitType> {
    return apiClient.post<VisitType>('/visit-types', data)
  }

  async update(id: number, data: UpdateVisitTypeRequest): Promise<VisitType> {
    return apiClient.put<VisitType>(`/visit-types/${id}`, data)
  }

  async delete(id: number): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(`/visit-types/${id}`)
  }
}

export const visitTypesRepository = new VisitTypesRepository()
